import { Injectable } from '@angular/core';
import {
  AbstractControl,
  Validators,
  FormGroup,
  FormArray,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';

import {
  State,
  District,
  Country,
  University,
  CollegeType,
  UserMenu,
  UserScreen,
  Institution,
  Organization,
  ADMIN_CONSTANT,
  Department,
  AcademicClass,
  AcademicSession,
  TransportRoute,
  College,
  NamePrefix,
  Gender,
  RunCycle
} from '../app.model';
import { AppService } from '../app.service';
import { ConfirmDialogComponent } from '../shared/components/confirm-dialog/confirm-dialog.component';

@Injectable()
export class DashboardService {
  states: BehaviorSubject<State[]> = new BehaviorSubject<State[]>(null);
  districts: BehaviorSubject<District[]> = new BehaviorSubject<District[]>(null);
  countries: BehaviorSubject<Country[]> = new BehaviorSubject<Country[]>(null);
  universities: BehaviorSubject<University[]> = new BehaviorSubject<University[]>(null);
  subjects: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  collegetypes: BehaviorSubject<CollegeType[]> = new BehaviorSubject<CollegeType[]>(null);
  institutions: BehaviorSubject<Institution[]> = new BehaviorSubject<
    Institution[]
  >(null);
  organizations: BehaviorSubject<Organization[]> = new BehaviorSubject<
    Organization[]
  >(null);
  depertments: BehaviorSubject<Department[]> = new BehaviorSubject<
    Department[]
  >(null);
  academicClasses: BehaviorSubject<AcademicClass[]> = new BehaviorSubject<
    AcademicClass[]
  >(null);
  academicSessions: BehaviorSubject<AcademicSession[]> = new BehaviorSubject<
    AcademicSession[]
  >(null);
  transportRoutes: BehaviorSubject<TransportRoute[]> = new BehaviorSubject<
    TransportRoute[]
  >(null);
  userInfo: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  userMenu: BehaviorSubject<UserMenu[]> = new BehaviorSubject<UserMenu[]>(null);
  userScreen: BehaviorSubject<UserScreen[]> = new BehaviorSubject<UserScreen[]>(
    null
  );
  mdmSelectedTable: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  collegeSelectedTable: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  collegeTypes: BehaviorSubject<CollegeType[]> = new BehaviorSubject<CollegeType[]>(null);
  colleges: BehaviorSubject<College[]> = new BehaviorSubject<College[]>(null);
  namePrefix: BehaviorSubject<NamePrefix[]> = new BehaviorSubject<NamePrefix[]>(null);
  gender: BehaviorSubject<Gender[]> = new BehaviorSubject<Gender[]>(null);
  runCycles: BehaviorSubject<RunCycle[]> = new BehaviorSubject<RunCycle[]>(null);
  constructor(
    private router: Router,
    public dialog: MatDialog,
    private service: AppService,
  ) { }

  getScreenAccessCode(screen: string): 'NO' | 'RO' | 'RW' {
    const USER_MENU_SCREEN: UserScreen[] = this.service.getToken(
      ADMIN_CONSTANT.ADMIN_TOKEN_ADMIN_USER_MENU_SCREEN
    );
    this.service.userScreenCode.next(screen);
    // console.log("screen", USER_MENU_SCREEN);

    if (!!USER_MENU_SCREEN && !!USER_MENU_SCREEN.length) {
      const _SCREEN = USER_MENU_SCREEN.find((f) => f.ScreenCode === screen);
      if (!_SCREEN) {
        this.service.showToast(ADMIN_CONSTANT.NO_ACCESS);
        this.service.accessCode = 'NO';
        return 'NO';
      } else if (!!_SCREEN && !!_SCREEN.ReadOnlyFlag) {
        this.service.accessCode = 'RO';
        return 'RO';
      } else {
        this.service.accessCode = 'RW';
        return 'RW';
      }
    }
  }

  checkNoAccessRole(redirectURL: string): void {
    if (this.service.accessCode === 'NO') {
      this.router.navigate(['dashboard', redirectURL], { replaceUrl: true });
    }
  }

  customEmailValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value) {
      const matches = control.value.match(
        // tslint:disable-next-line: max-line-length
        /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/gi
      );
      // /[a-z0-9!#$%&'+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'+/=?^_`{|}~-]+)@(?:[a-z0-9](?:[a-z0-9-][a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
      return !!matches && !Validators.email(control)
        ? null
        : { invalidEmail: true };
    } else {
      return null;
    }
  }

  customPhoneNumberValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value) {
      const matches = control.value.match(/^[0-9]{10}$/);
      return !!matches ? null : { invalidPhoneNumber: true };
    } else {
      return null;
    }
  }

  customURLValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value) {
      const matches = control.value.match(
        /^(?:(?:https|http):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i
      );
      // /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gi
      return !!matches ? null : { invalidURL: true };
    } else {
      return null;
    }
  }

  customCoordinateValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value) {
      const matches = `${control.value}`.match(/^[-+]?[0-9]{1,3}.[0-9]{2,}$/);
      return !!matches ? null : { invalidCoordinate: true };
    } else {
      return null;
    }
  }

  customIntegerValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value) {
      const matches = `${control.value}`.match(/^-?[0-9]\d*$/);
      return !!matches ? null : { invalidInteger: true };
    } else {
      return null;
    }
  }

  customPositiveIntegerValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value) {
      const matches = `${control.value}`.match(/^[0-9]\d*$/);
      return !!matches ? null : { invalidInteger: true };
    } else {
      return null;
    }
  }

  customCurrencyValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value) {
      const matches = `${control.value}`.match(/^-?[0-9]\d*(\.\d{1,2})?$/);
      return !!matches ? null : { invalidCurrency: true };
    } else {
      return null;
    }
  }

  customTimeValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (control.value) {
      const matches = `${control.value}`.match(
        /^(([1-9]|0[1-9]|1[0-2]{1}){1}:([0-5]{1}[0-9]{1}){1}([ ]?[a|p]m){1})|(([0-9]{1}|0[0-9]{1}|1[0-9]{1}|2[0-3]{1}):([0-5]{1}[0-9]{1}))$/
      );
      return !!matches ? null : { invalidTime: true };
    } else {
      return null;
    }
  }

  updateValueAndValidity(fg: FormGroup | FormArray): void {
    for (const key in fg.controls) {
      if (key) {
        const control = fg.get(key);
        if (control instanceof FormGroup || control instanceof FormArray) {
          this.updateValueAndValidity(control);
        } else {
          fg.get(key).updateValueAndValidity({ emitEvent: false });
        }
      }
    }
  }

  setAddressFormValidator(addressForm: FormGroup): void {
    addressForm.get('City').setValidators([Validators.required]);
    addressForm.get('City').updateValueAndValidity();
    addressForm.get('StateId').setValidators([Validators.required]);
    addressForm.get('StateId').updateValueAndValidity();
    // addressForm.get('HouseNo').setValidators([Validators.required]);
    addressForm.get('HouseNo').updateValueAndValidity();
    // addressForm.get('RoadName').setValidators([Validators.required]);
    addressForm.get('RoadName').updateValueAndValidity();
    addressForm.get('CountryId').setValidators([Validators.required]);
    addressForm.get('CountryId').updateValueAndValidity();
    addressForm
      .get('PostalCode')
      .setValidators([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(6),
        Validators.pattern(/^[0-9]{6}$/),
      ]);
    addressForm.get('PostalCode').updateValueAndValidity();
  }

  setImageFormValidator(imageForm: FormGroup): void { }

  canDeactivate(): Observable<boolean> {
    return this.dialog
      .open(ConfirmDialogComponent, {
        width: '325px',
        position: { top: '10%' },
        data: {
          header: 'Unsaved changes',
          message: 'Do you still want to proceed?',
        },
      })
      .afterClosed()
      .pipe(map((result) => result));
  }

  formatMoney(currency, value): string {
    // const temp = `${value}`.replace(/\,/g, '');
    // return this.currencyPipe.transform(temp).replace('$', '');
    return currency + ' ' + value;
  }
}
